import { Suspense, lazy, useEffect } from 'react';
import './App.scss';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom"
import Sidebar from './components/Common/Sidebar';
import DummyButton from './pages/DummyButton';
import PageLoading from './components/Common/PageLoading';
import Payment from './components/AdSetup/PaymentGateway';
import SuccessPayment from './components/AdSetup/SuccessPayment';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';
import { useDispatch } from 'react-redux';
import { setColorChange } from './components/features/AddCampaignSlice';



const AddCampaigns = lazy(() => import('./pages/AddCampaigns'));
const AdSetup = lazy(() => import("./pages/AdSetup"));
const CampaignAnalytics = lazy(() => import('./pages/CampaignAnalytics'));
const NewGraphQLPage = lazy(() => import('./pages/NewGraphQLPage'));
const DeveloperLogin = lazy(() => import('./pages/DeveloperLogin'));

function App() {

  const dispatch = useDispatch()
  const colorChange = useSelector((state: RootState) => state.campaign.colorChange);

  const params = useParams()
  const take = useLocation()
  // console.log(take)

  console.log("params", params)
  console.log("takes", take)


  useEffect(() => {
    dispatch(setColorChange(false))
  }, [])

  return (
    <div style={{ background: take.pathname === '/payment' && '#fff', minHeight: take.pathname === '/payment' && "100vh" }}>

      <Routes>
        <Route path='/' element={take.pathname !== "/" && take.pathname !== "/new" && take.pathname !== "/login" ? <Sidebar /> : null}>
          <Route path='/' element={<DummyButton />} />
          <Route path='/addcampaigns' element={<Suspense fallback={<PageLoading />}><AddCampaigns /></Suspense>} />
          <Route path='/new' element={<Suspense fallback={<PageLoading />}><NewGraphQLPage /></Suspense>} />
          <Route path='/payment' element={<Payment />} />
          <Route path='/success' element={<SuccessPayment />} />
          <Route path='/addcampaigns/adsetup' element={<Suspense fallback={<PageLoading />}><AdSetup /></Suspense>} />
          <Route path='/campaign-analytics' element={<Suspense fallback={<PageLoading />}><CampaignAnalytics /></Suspense>} />
          {/* {process.env.REACT_APP_ENV !== 'PRODUCTION' && ( */}
          <Route path='/login' element={<Suspense fallback={<PageLoading />}><DeveloperLogin /></Suspense>} />
          {/* )} */}
          <Route path='/*' element={<Navigate to="/addcampaigns" />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
